import React, { useState, useEffect, useCallback } from 'react';
import { Row, Space, Tooltip, InputNumber } from 'antd';
import { QuestionCircleOutlined, PlusCircleOutlined } from '@ant-design/icons';
import { v4 as uuidv4 } from 'uuid';
import DeleteIcon from '../../../../../assets/icons/Delete/Delete';
import colors from '../../../../../styles/colors';
import { SelectInput } from '../SelectInput';

import { useMatrizConsulta } from '../context';

import * as S from './styles';

export function TabelaEditar({ scroll }) {
  const {
    consultaLista,
    tipoConsultaLista,
    validarMatriz,
    matriz,
    updateValidarConsulta,
    matrizEditItem,
    isEditMatriz,
    updateMatriz,
    validarConsulta,
  } = useMatrizConsulta();
  const [dataSource, setDataSource] = useState([]);

  const filterTitleTooltip = column => {
    const text = {
      Consulta: 'Escolha quais consultas deseja incluir',
      'Tipo de Consulta': 'Escolha para quem esta consulta é destinada',
      Contingência:
        'Escolha uma consulta para substituir a principal em caso de falha',
      'Reprovação Automática':
        'Caso a consulta esteja marcada como reprovação automática, todas as consultas pendentes serão reprovadas assim como a solicitação',
      Validade: 'Informe a quantidade de dias para a validade da consulta.',
    };
    return text[column] || '';
  };

  const validateForm = (array = []) => array?.find(item => !item.idConsulta || !item.idTipoCadastro);

  const newConsultaTable = () => {
    const newconsulta = {
      diasValidadeConsulta: null,
      idConsulta: null,
      idTipoCadastro: null,
      idConsultaContigencia: null,
      reprovacaoAutomatica: false,
      indexKey: uuidv4(),
    };
    const interable = dataSource || [];
    return setDataSource([...interable, newconsulta]);
  };

  const handlerDelete = async (text, record, index) => {
    const data = [...dataSource];
    const newLits = data.filter(item => item?.indexKey !== record?.indexKey);
    setDataSource(newLits);
  };

  const mergedChanges = (row, value, title) => {
    const mapItem = dataSource?.map(item => row?.indexKey === item?.indexKey
        ? {
            ...item,
            [title]: value,
          }
        : item);
    setDataSource(mapItem);
  };

  const formatarMatrizUpdate = useCallback(
    (matrizAtual = {}) => {
      if (!validarConsulta) {
        updateMatriz({
          ...matrizAtual,
          consultas: dataSource,
        });
      }
    },
    [validarConsulta, dataSource, updateMatriz]
  );

  useEffect(() => {
    updateValidarConsulta(!!validateForm(dataSource));
  }, [dataSource, updateValidarConsulta]);

  useEffect(() => {
    formatarMatrizUpdate(matriz);
  }, [formatarMatrizUpdate]);

  useEffect(() => {
    const arrayConsulta = isEditMatriz ? matrizEditItem?.consultas : [];
    const newConsultItem = arrayConsulta?.map(item => ({
        ...item,
        indexKey: uuidv4(),
      }));
    setDataSource(newConsultItem);
  }, [matrizEditItem, isEditMatriz]);

  const titleColumn = text => (
    <Space
      style={{
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <S.TitleTable>{text}</S.TitleTable>
      <Tooltip title={filterTitleTooltip(text)}>
        <QuestionCircleOutlined
          style={{
            color: colors.verde,
          }}
        />
      </Tooltip>
    </Space>
  );

  const columns = [
    {
      title: titleColumn('Validade'),
      dataIndex: 'diasValidadeConsulta',
      key: 'diasValidadeConsulta',
      width: '18%',
      align: 'left',
      render: (_, action) => (
          <S.RowContent>
            <InputNumber
              style={{
                backgroundColor: '#F2F2F2',
                color: '#828282',
                fontSize: '14px',
                lineHeight: '20px',
              }}
              value={action?.diasValidadeConsulta}
              min={0}
              onChange={e => mergedChanges(action, e, 'diasValidadeConsulta')}
              placeholder="Dias"
            />
          </S.RowContent>
        ),
    },
    {
      title: titleColumn('Consulta'),
      dataIndex: 'consulta',
      key: 'consulta',
      width: '28%',
      align: 'left',
      render: (_, action) => (
          <S.RowContent>
            <SelectInput
              width={100}
              valueSelec="nome"
              select="id"
              value={action?.idConsulta}
              placeholder="Selecione Consulta"
              handlerChange={e => mergedChanges(action, e, 'idConsulta')}
              options={consultaLista || []}
            />
          </S.RowContent>
        ),
    },
    {
      title: titleColumn('Tipo'),
      dataIndex: 'tipoConsulta',
      key: 'tipoConsulta',
      width: '28%',
      align: 'left',
      render: (_, action) => (
        <S.RowContent>
          <SelectInput
            width={100}
            valueSelec="nome"
            select="id"
            value={action?.idTipoCadastro}
            placeholder="Selecione tipo de Consulta"
            handlerChange={e => mergedChanges(action, e, 'idTipoCadastro')}
            options={tipoConsultaLista || []}
          />
        </S.RowContent>
      ),
    },
    {
      title: titleColumn('Contingência'),
      dataIndex: 'contingencia',
      key: 'contingencia',
      width: '28%',
      align: 'left',
      render: (_, action) => (
        <S.RowContent>
          <SelectInput
            allowClear
            width={100}
            valueSelec="nome"
            select="id"
            value={action?.idConsultaContigencia}
            placeholder="Selecione Contigência"
            handlerChange={e =>
              mergedChanges(action, e, 'idConsultaContigencia')
            }
            options={consultaLista || []}
          />
        </S.RowContent>
      ),
    },
    {
      title: titleColumn('Reprovação Automática'),
      dataIndex: 'reprovacaoAutomatica',
      key: 'reprovacaoAutomatica',
      width: '15%',
      align: 'left',
      render: (text, record, index) => (
        <S.RowContent>
          <S.RowActions>
            <Space>
              <S.CheckboxCustom
                checked={record?.reprovacaoAutomatica}
                onChange={e =>
                  mergedChanges(
                    record,
                    e?.target?.checked,
                    'reprovacaoAutomatica'
                  )
                }
              />
            </Space>
          </S.RowActions>
        </S.RowContent>
      ),
    },
    {
      title: '',
      dataIndex: 'excluir',
      key: 'excluir',
      width: '6%',
      align: 'center',
      render: (text, record, index) => (
        <S.RowContent>
          <S.RowActions>
            <Space
              style={{
                cursor: 'pointer',
                padding: '4px 0 0 0',
                margin: '0 0 0 8px',
              }}
            >
              <DeleteIcon
                height={19}
                width={15}
                onClick={() => handlerDelete(text, record, index)}
              />
            </Space>
          </S.RowActions>
        </S.RowContent>
      ),
    },
  ];

  return (
    <S.ContainerTable>
      <Row
        style={{
          width: '100%',
        }}
      >
        <S.TableCustom
          scroll={{ y: scroll - 200 }}
          columns={columns}
          dataSource={dataSource}
          pagination={false}
        />
      </Row>
      <Row
        style={{
          width: '100%',
        }}
      >
        <S.AddItem onClick={newConsultaTable} event={!validarMatriz}>
          <PlusCircleOutlined />
          Adicionar Consulta
        </S.AddItem>
      </Row>
    </S.ContainerTable>
  );
}
